import { useAuth } from "../context/AuthContext";

const WRITE_ROLES = new Set(["super_admin", "admin", "manager", "vet"]);
const DELETE_ROLES = new Set(["super_admin", "admin", "manager"]);

// ENH-OwnerWrite: separate helper so owner-specific UI is gated independently
// of `canEdit` / `canDelete` — those keep their existing semantics for
// admin/manager/vet unchanged.
export const canOwnerWrite = (role) => role === "owner";

/**
 * Returns booleans for what the current user can do.
 * Super_admin while impersonating uses the impersonated role (admin) which works.
 */
export function usePermissions() {
  const { user } = useAuth();
  const role = user?.role;
  return {
    canEdit: WRITE_ROLES.has(role),
    canDelete: DELETE_ROLES.has(role),
    role,
  };
}
